const configurationLandingEs = {
  configuration_landing: {
    page_title: `Configuraciones`,
    document_title: `Documento`,
    document_description: `Configura los campos de tus documentos`,
    mapping_title: `Mapeo`,
    mapping_description: `Automatiza las reglas de mapeo de campos`,
    export_title: `Exportar`,
    export_description: `Gestiona cómo se exportan los documentos`,
    discrepancy_title: `Discrepancia`,
    discrepancy_description: `Configura reglas para detectar discrepancias en documentos`,
    workflow_title: `Flujo de trabajo`,
    workflow_description: `Gestiona el enrutamiento de aprobaciones y alertas`,
    coding_template_title: `Plantilla de Codificación`,
    coding_template_description: `Divide los costos de facturas por dimensiones según el proveedor`,
    posting_date_policy_title: `Política de Fecha de Contabilización`,
    posting_date_policy_description: `Configura reglas para determinar la fecha en que las facturas se contabilizan`,
    peppol_party_registration_title: `Registro de Participante en Peppol`,
    peppol_party_registration_description: `Gestionar el registro de participantes en peppol`,
    extraction_configuration_title: `Configuración de Extracción`,
    extraction_configuration_description: `Configura reglas para eliminar marcas de agua y procesar la primera página`,
    validation_title: `Configuración de Validación`,
    validation_description: `Elige qué campos se validan en los documentos estandarizados`,
  },
};

export default configurationLandingEs;
